// GENERATED by scripts/sounds.mjs — do not edit. Change the cue table there
// and re-run `node scripts/sounds.mjs`, which rewrites this file and the mp3
// together so the offsets can never drift from the audio they point at.

/**
 * Howler's sprite shape, restated rather than imported: use-sound declares
 * `SpriteMap` in its types but does not re-export it from the package entry.
 * Written as `satisfies` so the keys stay literal and `CueName` below is the
 * seven real cues rather than `string`.
 */
type SpriteMap = Record<string, [number, number]>;

/** Where each cue lives in cues.mp3: [start ms, duration ms]. */
export const CUE_SPRITE = {
  press: [0, 165],
  ate: [400, 362],
  tossed: [800, 338],
  still: [1200, 210],
  add: [1600, 360],
  remove: [2000, 305],
  error: [2400, 400],
} satisfies SpriteMap;

export type CueName = keyof typeof CUE_SPRITE;
